import {GridWidgetTask} from './grid-widget-task';
import {Subject} from 'rxjs';
export class CompleteTask extends GridWidgetTask {

  name = 'grid-widget-complete';

  observable: Subject<Array<any>>;

  //This gives the grid widget object a chance to run something before informing
  //Everyone else that the task chain is complete.
  gwCallback: () => void;

  //This is passed in from the grid widget so that it's easier
  //for outside controls to subscribe.
  constructor(observable: Subject<Array<any>>, gwCallback: () => void) {
    super();
    this.gwCallback = gwCallback;
    this.observable = observable;
  }

  getPriority(): number {
    return GridWidgetTask.COMPLETE_TASK_PRIORITY;
  }

  preRunSetup(): void {
    //run this during preRunSetup so that it will be called even in server side mode.
    this.gwCallback();
  }

  run(data: Array<any>): Array<any> {
    //No op. Just return the data.
    return data;
  }

  setGridWidgetTaskActive(value: boolean): void {
    //no op. This thing is always on.
  }

  execute(): void {
    //Since the run function in this task is synchronous,
    //The execute function will therefore by synchronous.
    super.execute();

    //Now that everything has executed update anyone wanting to know
    //about completed tasks.
    this.observable.next(this.result);
  }
}
